import { takeLatest, call, put, debounce } from 'redux-saga/effects';
import { message } from 'antd';
import httpClient from '../../../utils/HttpClient';
import { CART_COUNT_URL, CART_URL } from '../../../constants/Url';
import { 
  FETCH_CART_REQUEST,
  FETCH_CART_SUCCESS,
  FETCH_CART_COUNT_SUCCESS,
  FETCH_CART_FAILURE,
  ADD_TO_CART_REQUEST,
  REMOVE_FROM_CART_REQUEST,
  UPDATE_QUANTITY_REQUEST,
  CLEAR_CART_REQUEST,
  FETCH_CART_COUNT_REQUEST
} from '../../shop/actionTypes';
import { fetchCartRequest, fetchCartCountRequest } from '../../shop/actions';

function* fetchCartCount() {
  try {
    const cartCountRes = yield call(httpClient.get, CART_COUNT_URL);
    if (cartCountRes.data && cartCountRes.data.status === 200) {
      yield put({ type: FETCH_CART_COUNT_SUCCESS, payload: cartCountRes.data.data || 0 });
    }
  } catch (error) {
  }
}

function* fetchCart() {
  try {
    const res = yield call(httpClient.get, CART_URL);
    if (res.data && res.data.status === 200) {
      yield put({ type: FETCH_CART_SUCCESS, payload: res.data.data });
    } else {
      yield put({ type: FETCH_CART_FAILURE, payload: res.data?.message || 'Error fetching cart' });
    }
  } catch (error) {
    yield put({ type: FETCH_CART_FAILURE, payload: error.message });
  }
}

function* addToCart(action) {
  try {
    const res = yield call(httpClient.post, `${CART_URL}/item`, action.payload);
    if (res.data && res.data.status === 200) {
      // Re-fetch cart
      yield put(fetchCartRequest());
      // Re-fetch cart count
      yield put(fetchCartCountRequest());
    } else {
      message.error(res.data?.message || 'Error adding to cart');
    }
  } catch (error) {
    message.error('Error adding to cart');
  }
}

function* updateQuantity(action) {
  try {
    const { itemId, qty, productId } = action.payload;
    const res = yield call(httpClient.patch, `${CART_URL}/${itemId}/item`, { qty, productId });
    if (res.data && res.data.status === 200) {
      // Re-fetch cart
      yield put(fetchCartRequest());
      // Re-fetch cart count
      yield put(fetchCartCountRequest());
    } else {
      message.error(res.data?.message || 'Error updating cart');
    }
  } catch (error) {
    message.error('Error updating cart');
  }
}

function* removeFromCart(action) {
  try {
    const itemId = action.payload;
    const res = yield call(httpClient.delete, `${CART_URL}/${itemId}/item`);
    if (res.data && res.data.status === 200) {
      // Re-fetch cart
      yield put(fetchCartRequest());
      // Re-fetch cart count
      yield put(fetchCartCountRequest());
    } else {
      message.error(res.data?.message || 'Error removing from cart');
    }
  } catch (error) {
    message.error('Error removing from cart');
  }
}

function* clearCartSaga(action) {
  try {
    const cartId = action.payload;
    const res = yield call(httpClient.delete, `${CART_URL}/${cartId}/clear`);
    if (res.data && res.data.status === 200) {
      yield put(fetchCartRequest());
      yield put(fetchCartCountRequest());
    } else {
      message.error(res.data?.message || 'Error clearing cart');
    }
  } catch (error) {
    message.error('Error clearing cart');
  }
}

export function* cartWatcher() {
  yield takeLatest(FETCH_CART_REQUEST, fetchCart);
  yield takeLatest(FETCH_CART_COUNT_REQUEST, fetchCartCount);
  yield takeLatest(ADD_TO_CART_REQUEST, addToCart);
  yield debounce(500, UPDATE_QUANTITY_REQUEST, updateQuantity);
  yield takeLatest(REMOVE_FROM_CART_REQUEST, removeFromCart);
  yield takeLatest(CLEAR_CART_REQUEST, clearCartSaga);
}
